<template>
  <div>
    <q-file
      ref="filePicker"
      v-show="false"
      @input="setFile"
      :accept="accept"
    />
    <q-input
      filled
      clearable
      v-model="text"
      @input="setString"
      :label="label"
    >
      <template slot="append">
        <slot name="addBtn"/>
        <q-btn
          flat
          icon="attach_file"
          @click.stop="pickFiles"
        ></q-btn>
      </template>
    </q-input>
  </div>
</template>

<script>
import { QBtn, QFile, QInput } from 'quasar'

export default {
  props: ['value', 'accept', 'label'],
  components: {
    QBtn, QFile, QInput
  },
  data () {
    return {
      isPwd: true,
      text: ''
    }
  },
  methods: {
    pickFiles () {
      this.$refs.filePicker.pickFiles()
    },
    setFile (file) {
      this.text = file.name
      this.setInput({
        type: 'file',
        value: file
      })
    },
    setString (value) {
      this.setInput({
        type: 'string',
        value
      })
    },
    setInput (object) {
      this.$emit('input', object)
    }
  }
}
</script>
